import {
    AUTH_DASHBOARD_URL
} from '@/constants/auth.js';

const routes = [
    /* Auth */
    {
        path: '/',
        name: 'login',
        meta: {
            layout: 'auth',
            authenticatedRedirect: AUTH_DASHBOARD_URL
        },
        component: require('@/views/Login').default
    },
    /* Dashboard */
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/Home').default
    },
    /* Translations */
    {
        path: '/translations',
        name: 'translations.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/translations/Home').default
    },
    /* Users */
    {
        path: '/users',
        name: 'users.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/users/Home').default
    },
    {
        path: '/users/edit/:id',
        name: 'users.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/users/Edit').default,
        props: true
    },
    {
        path: '/users/new',
        name: 'users.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/users/New').default
    },
    /* Forms */
    {
        path: '/forms',
        name: 'forms.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/forms/Home').default
    },
    {
        path: '/forms/:handle',
        name: 'forms.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/forms/Edit').default,
        props: true
    },
    /* Referral */
    {
        path: '/referrals',
        name: 'referrals.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/referrals/Home').default
    },
    {
        path: '/referrals/new',
        name: 'referrals.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/referrals/New').default
    },
    {
        path: '/referrals/edit/:id',
        name: 'referrals.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/referrals/Edit').default
    },
    /* Groups */
    {
        path: '/groups',
        name: 'groups.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/groups/Home').default
    },
    {
        path: '/groups/new',
        name: 'groups.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/groups/New').default
    },
    {
        path: '/groups/edit/:id',
        name: 'groups.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/groups/Edit').default,
        props: true
    },
    /* Media */
    {
        path: '/media',
        name: 'media.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/media/Home').default
    },
    /* Pages */
    {
        path: '/pages',
        name: 'pages.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/pages/Home').default
    },
    {
        path: '/pages/new',
        name: 'pages.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/pages/New').default
    },
    {
        path: '/pages/new/:id',
        name: 'pages.new.child',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/pages/New').default
    },
    {
        path: '/pages/edit/:id',
        name: 'pages.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/pages/Edit').default
    },
    /* Services */
    {
        path: '/services',
        name: 'services.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/services/Home').default
    },
    {
        path: '/services/new',
        name: 'services.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/services/New').default
    },
    {
        path: '/services/new/:id',
        name: 'services.new.child',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/services/New').default
    },
    {
        path: '/services/edit/:id',
        name: 'services.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/services/Edit').default
    },
    {
        path: '/services/view/:id',
        name: 'services.view',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/services/View').default
    },
    {
        path: '/services/drafts/:id',
        name: 'services.drafts.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/services/drafts/Home').default
    },
    /* Tyres */
    {
        path: '/tyres',
        name: 'tyres.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/tyres/Home').default
    },
    {
        path: '/tyres/new',
        name: 'tyres.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/tyres/New').default
    },
    {
        path: '/tyres/new/:id',
        name: 'tyres.new.child',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/tyres/New').default
    },
    {
        path: '/tyres/edit/:id',
        name: 'tyres.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/tyres/Edit').default
    },
    /* Offers */
    {
        path: '/offers',
        name: 'offers.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/offers/Home').default
    },
    {
        path: '/offers/new',
        name: 'offers.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/offers/New').default
    },
    {
        path: '/offers/new/:id',
        name: 'offers.new.child',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/offers/New').default
    },
    {
        path: '/offers/edit/:id',
        name: 'offers.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/offers/Edit').default
    },
    {
        path: '/offers/view/:id',
        name: 'offers.view',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/offers/View').default
    },
    {
        path: '/offers/drafts/:id',
        name: 'offers.drafts.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/offers/drafts/Home').default
    },
    /* Careers */
    {
        path: '/careers',
        name: 'careers.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/careers/Home').default
    },
    {
        path: '/careers/new',
        name: 'careers.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/careers/New').default
    },
    {
        path: '/careers/new/:id',
        name: 'careers.new.child',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/careers/New').default
    },
    {
        path: '/careers/edit/:id',
        name: 'careers.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/careers/Edit').default
    },
    {
        path: '/careers/view/:id',
        name: 'careers.view',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/careers/View').default
    },
    {
        path: '/careers/drafts/:id',
        name: 'careers.drafts.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/careers/drafts/Home').default
    },
    /* Articles */
    {
        path: '/articles',
        name: 'articles.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/articles/Home').default
    },
    {
        path: '/articles/new',
        name: 'articles.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/articles/New').default
    },
    {
        path: '/articles/new/:id',
        name: 'articles.new.child',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/articles/New').default
    },
    {
        path: '/articles/edit/:id',
        name: 'articles.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/articles/Edit').default
    },
    {
        path: '/articles/view/:id',
        name: 'articles.view',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/articles/View').default
    },
    {
        path: '/articles/drafts/:id',
        name: 'articles.drafts.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/articles/drafts/Home').default
    },
    /* Locations */
    // {
    //     path: '/locations',
    //     name: 'locations.home',
    //     meta: {
    //         layout: 'default',
    //         auth: true
    //     },
    //     component: require('@/views/locations/Home').default
    // },
    {
        path: '/locations/new',
        name: 'locations.new',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/locations/New').default
    },
    {
        path: '/locations/new/:id',
        name: 'locations.new.child',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/locations/New').default
    },
    {
        path: '/settings',
        name: 'locations.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/locations/Edit').default
    },
    {
        path: '/locations/view/:id',
        name: 'locations.view',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/locations/View').default
    },
    /* Menus */
    {
        path: '/menus',
        name: 'menus.home',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/menus/Home').default
    },
    {
        path: '/menus/edit/:id',
        name: 'menus.edit',
        meta: {
            layout: 'default',
            auth: true
        },
        component: require('@/views/menus/Edit').default
    },
    // /* Settings */
    // {
    //     path: '/settings',
    //     name: 'settings.home',
    //     meta: {
    //         layout: 'default',
    //         auth: true
    //     },
    //     component: require('@/views/settings/Home').default
    // },
    // /* Settings */
    // {
    //     path: '/quicklinks',
    //     name: 'quicklinks.home',
    //     meta: {
    //         layout: 'default',
    //         auth: true
    //     },
    //     component: require('@/views/quicklinks/Home').default
    // }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js